import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './lib/AuthContext';
import { installErrorCapture } from './lib/errorCapture';
import './styles/theme.css';

// Wire frontend errors → POST /errors → ErrorsTable → vtt-errors MCP server.
// VITE_API_URL is the same HTTP API the rest of the SPA uses; the /errors
// route is intentionally unauthenticated so this works even on the login
// page or boot-time crashes before AuthProvider has a session.
const apiUrl = import.meta.env.VITE_API_URL as string | undefined;
if (apiUrl) {
  installErrorCapture({
    endpoint: `${apiUrl.replace(/\/$/, '')}/errors`,
    release: (import.meta.env.VITE_RELEASE as string | undefined) ?? 'unknown',
    source: 'frontend',
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
